//      
                                                    
                                               
import getScroll from './get-scroll';
import { canScrollWindow } from '../can-scroll';

              
                     
                
                   
                        
                                  
   

export default ({
  viewport,
  subject,
  center,
  dragStartTime,
  shouldUseTimeDampening,
}      )            => {
  const scroll            = getScroll({
    dragStartTime,
    container: viewport.frame,
    subject,
    center,
    shouldUseTimeDampening,
  });

  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/auto-scroller/fluid-scroller/get-window-scroll-change.js